import Cookies from "js-cookie"

export default {
    state: {
        perms: [],  // 用户权限标识集合
        user: undefined,
    },
    getters: {

    },
    mutations: {
        setPerms(state, perms) {  // 用户权限标识集合
            state.perms = perms;
        },
        GET_USER(state, page) {
            let user = state.user;
            if (!user) {
                const user_ = sessionStorage.getItem('userinfo');
                user = user_ && JSON.parse(user_);
            }
            page.user = user;
        },
        SET_USER(state, user) {
            state.user = user;
            const { jti, username } = user;

            Cookies.set('jti', jti) // 放置token到Cookie
            sessionStorage.setItem('user', username) // 保存用户到本地会话
            sessionStorage.setItem("userinfo", JSON.stringify(user));
        },
    },
    actions: {
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js